export default "__VITE_ASSET__2kWXhzGG__"